/** @format */

import React from 'react';
import { notificationActions } from '../modules/notifications/actions';
import i18n from '../core/i18n';
import { Close } from 'mdi-material-ui';
import IconButton from '@material-ui/core/IconButton';

export class NotificationHelper {
    static notifyError = (message, dispatch) => {
        dispatch(
            notificationActions.enqueueSnackbar({
                message: i18n.t(message),
                options: {
                    preventDuplicate: true,
                    key: new Date().getTime() + Math.random(),
                    variant: 'error',
                    action: (key) => (
                        <IconButton
                            key="close"
                            aria-label="close"
                            color="inherit"
                            onClick={() => NotificationHelper.closeNotification(key, dispatch)}
                        >
                            <Close />
                        </IconButton>
                    ),
                },
            })
        );
    };

    static notifySuccess = (message, dispatch) => {
        dispatch(
            notificationActions.enqueueSnackbar({
                message: i18n.t(message),
                options: {
                    preventDuplicate: true,
                    key: new Date().getTime() + Math.random(),
                    variant: 'success',
                    action: (key) => (
                        <IconButton
                            key="close"
                            aria-label="close"
                            color="inherit"
                            onClick={() => NotificationHelper.closeNotification(key, dispatch)}
                        >
                            <Close />
                        </IconButton>
                    ),
                },
            })
        );
    };

    static notifyCustom = (message, dispatch, variant) => {
        dispatch(
            notificationActions.enqueueSnackbar({
                message: i18n.t(message),
                options: {
                    preventDuplicate: true,
                    key: new Date().getTime() + Math.random(),
                    variant: variant,
                    action: (key) => (
                        <IconButton
                            key="close"
                            aria-label="close"
                            color="inherit"
                            onClick={() => NotificationHelper.closeNotification(key, dispatch)}
                        >
                            <Close />
                        </IconButton>
                    ),
                },
            })
        );
    };

    /**
     * YOU HAVE TO PROGRAMATICALLY REMOVE NOTIFICATION IF YOU USE noManualAction!!!
     * @param message
     * @param dispatch
     * @param variant
     * @param noManualAction
     * @param messageOptions
     */
    static notifyCustomPernament = (message, dispatch, variant, noManualAction = false, messageOptions = {}) => {
        dispatch(
            notificationActions.enqueueSnackbar({
                message: i18n.t(message, messageOptions),
                options: {
                    preventDuplicate: true,
                    persist: true,
                    key: new Date().getTime() + Math.random(),
                    variant: variant,
                    action: (key) => {
                        if (!noManualAction) {
                            return (
                                <IconButton
                                    key="close"
                                    aria-label="close"
                                    color="inherit"
                                    onClick={() => NotificationHelper.closeNotification(key, dispatch)}
                                >
                                    <Close />
                                </IconButton>
                            );
                        }
                    },
                },
            })
        );
    };

    static closeNotification = (key, dispatch) => {
        dispatch(notificationActions.closeSnackbar(key));
    };

    static closeAllNotifications = (dispatch) => {
        dispatch(notificationActions.closeSnackbar());
    };

    static notifySaveSuccess = (dispatch) => {
        NotificationHelper.notifySuccess(i18n.t('general:common.changes_saved'), dispatch);
    };

    static notifyDefaultError = (dispatch) => {
        NotificationHelper.notifySuccess(i18n.t('general:common.error_occurred'), dispatch);
    };
}
